import { render, staticRenderFns } from "./UserLocalisationModal.vue?vue&type=template&id=4e2a2f6f"
import script from "./UserLocalisationModal.vue?vue&type=script&lang=js"
export * from "./UserLocalisationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports